/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {useLang, setLanguage} from '../../../i18n/Metronici18n'

const languages = [
  {
    lang: 'fa',
    name: 'فارسی',
    flag: toAbsoluteUrl('/media/flags/iran.svg'),
  },
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
  {
    lang: 'ar',
    name: 'العربية',
    flag: toAbsoluteUrl('/media/flags/saudi-arabia.svg'),
  },
  {
    lang: 'de',
    name: 'Deutsch',
    flag: toAbsoluteUrl('/media/flags/germany.svg'),
  },
  {
    lang: 'es',
    name: 'Espanol',
    flag: toAbsoluteUrl('/media/flags/spain.svg'),
  },
  {
    lang: 'fr',
    name: 'Francais',
    flag: toAbsoluteUrl('/media/flags/france.svg'),
  },
  {
    lang: 'ja',
    name: 'Japanese',
    flag: toAbsoluteUrl('/media/flags/japan.svg'),
  },
  {
    lang: 'tr',
    name: 'Turkce',
    flag: toAbsoluteUrl('/media/flags/turkey.svg'),
  },
  {
    lang: 'zh',
    name: 'Chinese',
    flag: toAbsoluteUrl('/media/flags/china.svg'),
  },
  {
    lang: 'ru',
    name: 'Русский',
    flag: toAbsoluteUrl('/media/flags/russia.svg'),
  },
]

const Languages: FC = () => {
  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)
  return (
    <div className='menu' data-kt-menu='true'>
      <div
        className='menu-item'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-start'
        data-kt-menu-flip='bottom'
      >
        <a
          href='#'
          className='menu-link language-trigger d-flex align-items-center gap-2 px-3 py-2 rounded'
          onClick={(e) => e.preventDefault()}
        >
          <img
            className='language-trigger__flag w-20px h-20px rounded-1 flex-shrink-0'
            src={currentLanguage?.flag}
            alt=''
          />
          <span className='language-trigger__name fw-semibold'>{currentLanguage?.name}</span>
        </a>

      <div className='menu-sub menu-sub-dropdown w-175px py-4'>
        {languages.map((l) => (
          <div
            className='menu-item px-3'
            key={l.lang}
            onClick={(e) => {
              e.preventDefault()
              setLanguage(l.lang)
            }}
          >
            <a
              href='#'
              className={clsx('menu-link d-flex px-5', {active: l.lang === currentLanguage?.lang})}
              onClick={(e) => e.preventDefault()}
            >
              <span className='symbol symbol-20px ms-2 me-2'>
                <img className='rounded-1' src={l.flag} alt='metronic' />
              </span>
              {l.name}
            </a>
          </div>
        ))}
      </div>
    </div>
    </div>
  )
}

export {Languages}
